import { getSnapshot, types } from 'mobx-state-tree'
import { DOMAIN_ACTION } from '@/constants'
import { IValueChange } from '@/pages/supplier/listing/definition/accountDetails'

export const SocialProfileModel = types
  .model('')
  .props({
    facebook_link: types.maybeNull(types.string),
    instagram_link: types.maybeNull(types.string),
    twitter_link: types.maybeNull(types.string),
    pinterest_link: types.maybeNull(types.string),
    youtube_link: types.maybeNull(types.string),
    vimeo_link: types.maybeNull(types.string),
    tiktok_link: types.maybeNull(types.string),
    listing_setup_step: types.optional(types.number, 4),
    status: types.optional(
      types.enumeration('status', ['changed', 'keep']),
      'keep'
    ),
  })
  .actions((self: any) => {
    const setStatus = (value: 'changed' | 'keep') => {
      self.status = value
    }

    const mapValueChanged = ({ add, value: { url } }: IValueChange) => {
      switch (add) {
        case 'facebook_link':
          self.facebook_link = url
          break
        case 'instagram_link':
          self.instagram_link = url
          break
        case 'twitter_link':
          self.twitter_link = url
          break
        case 'pinterest_link':
          self.pinterest_link = url
          break
        case 'youtube_link':
          self.youtube_link = url
          break
        case 'vimeo_link':
          self.vimeo_link = url
          break
        case 'tiktok_link':
          self.tiktok_link = url
          break
        default:
          null
          break
      }
      setStatus('changed')
    }

    const update = async (id: string, value: any = null) => {
      const socialLink = value || { ...Object(getSnapshot(self)) }
      delete socialLink.status
      const URI = `${DOMAIN_ACTION.API.UPDATE_SUPPLIER_LISTING(id)}`
      const payload = {
        ...socialLink,
        listing_setup_step: 4,
      }

      const res = await fetch(URI, {
        method: 'PUT',
        body: JSON.stringify(payload),
      })
      return res
    }

    return { setStatus, mapValueChanged, update }
  })
